"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get LAB_FILE_ALLOWED_CONTENT_TYPES () {
        return LAB_FILE_ALLOWED_CONTENT_TYPES;
    },
    get LAB_FILE_MAX_BYTES () {
        return LAB_FILE_MAX_BYTES;
    },
    get LAB_FILE_NOT_AVAILABLE () {
        return LAB_FILE_NOT_AVAILABLE;
    },
    get LAB_FILE_OPAQUE_CONTENT_TYPE () {
        return LAB_FILE_OPAQUE_CONTENT_TYPE;
    },
    get LAB_FILE_OPAQUE_KINDS () {
        return LAB_FILE_OPAQUE_KINDS;
    },
    get LabFileKindSchema () {
        return LabFileKindSchema;
    },
    get LabFileListResponseSchema () {
        return LabFileListResponseSchema;
    },
    get LabFileRejectReasonSchema () {
        return LabFileRejectReasonSchema;
    },
    get LabFileSchema () {
        return LabFileSchema;
    },
    get LabFileStatusSchema () {
        return LabFileStatusSchema;
    },
    get isLabFileOpaqueKind () {
        return isLabFileOpaqueKind;
    },
    get isLabFileTypeAllowed () {
        return isLabFileTypeAllowed;
    },
    get labFileServedContentType () {
        return labFileServedContentType;
    }
});
const _zod = require("zod");
const _result = require("../emra/result");
const LAB_FILE_MAX_BYTES = 104857600;
const LabFileKindSchema = _zod.z.enum(_result.EMRA_ATTACHMENT_KINDS);
const LabFileStatusSchema = _zod.z.enum([
    'pending',
    'stored',
    'rejected',
    'failed'
]);
const LabFileRejectReasonSchema = _zod.z.enum([
    'type_not_allowed',
    'too_large',
    'content_mismatch'
]);
const LAB_FILE_ALLOWED_CONTENT_TYPES = [
    'image/jpeg',
    'audio/wav',
    'audio/x-wav',
    'audio/wave',
    'audio/aac',
    'video/3gpp',
    'audio/3gpp',
    'video/mp4',
    'audio/mp4'
];
const LAB_FILE_OPAQUE_KINDS = [
    'ecg'
];
const LAB_FILE_OPAQUE_CONTENT_TYPE = 'application/octet-stream';
function isLabFileOpaqueKind(kind) {
    return LAB_FILE_OPAQUE_KINDS.includes(kind);
}
function isLabFileTypeAllowed(kind, contentType) {
    if (isLabFileOpaqueKind(kind)) {
        return true;
    }
    return LAB_FILE_ALLOWED_CONTENT_TYPES.includes(contentType);
}
function labFileServedContentType(kind, contentType) {
    if (isLabFileOpaqueKind(kind)) {
        return LAB_FILE_OPAQUE_CONTENT_TYPE;
    }
    return contentType;
}
const LabFileSchema = _zod.z.object({
    id: _zod.z.string().uuid(),
    kind: LabFileKindSchema,
    contentType: _zod.z.string().min(1),
    sizeBytes: _zod.z.number().int().min(0),
    status: LabFileStatusSchema,
    rejectReason: LabFileRejectReasonSchema.nullable()
}).strict().superRefine((file, ctx)=>{
    const isRejected = file.status === 'rejected';
    const hasReason = file.rejectReason !== null;
    if (isRejected !== hasReason) {
        ctx.addIssue({
            code: 'custom',
            path: [
                'rejectReason'
            ],
            message: 'rejectReason must be set if and only if status is rejected.'
        });
    }
});
const LabFileListResponseSchema = _zod.z.object({
    items: _zod.z.array(LabFileSchema),
    total: _zod.z.number().int().min(0)
}).strict();
const LAB_FILE_NOT_AVAILABLE = 'LAB_FILE_NOT_AVAILABLE';
